import './BpArticle.css'
import React from 'react'
import { IconShoppingBagX } from '../../icons/IconShoppingBagX'
import { useTranslation } from 'react-i18next'

export interface IBpArticleProps {
  title?: string
  text?: string
  link?: string
  href?: string
  searchScreenUrl?: string
  linkScreenUrl?: string
  shoppingAdPreviewUrl?: string
}

export const BpArticle = ({
  title,
  text,
  link,
  href,
  searchScreenUrl,
  linkScreenUrl,
  shoppingAdPreviewUrl,
}: IBpArticleProps) => {
  const { t } = useTranslation()
  const [imagePlug, setImagePlug] = React.useState(false)

  return (
    <article className='flex flex-col text-[14px] leading-[18px]'>
      <div className={'flex gap-[10px]'}>
        {shoppingAdPreviewUrl &&
          (imagePlug ? (
            <div className={'flex min-w-[67px] max-w-[67px] flex-col items-center gap-[4px]'}>
              <span className={'text-[10px] text-aqua-300'}>no image</span>
              <div className={'w-[48px] opacity-25'}>
                <IconShoppingBagX color={'#a059ff'} />
              </div>
            </div>
          ) : (
            <div className={'min-w-[67px] max-w-[67px]'}>
              <img
                className={'w-full rounded-[6px]'}
                src={shoppingAdPreviewUrl}
                onError={() => setImagePlug(true)}
              />
            </div>
          ))}
        <div>
          {href
            ? title && (
                <a
                  className='block text-inh font-semibold leading-[16px] text-focus-400'
                  dangerouslySetInnerHTML={{ __html: title }}
                  href={href}
                  rel='noreferrer'
                  target='_blank'
                ></a>
              )
            : title && (
                <h4
                  className='text-inh font-semibold leading-[16px] text-focus-400'
                  dangerouslySetInnerHTML={{ __html: title }}
                ></h4>
              )}
          {text && (
            <p
              className='leading-[18px] text-focus-600'
              dangerouslySetInnerHTML={{ __html: text }}
            ></p>
          )}
          {href
            ? link && (
                <a
                  className='break-all leading-[18px] text-success-400 hover:text-success-400'
                  dangerouslySetInnerHTML={{ __html: link }}
                  href={href}
                  rel='noreferrer'
                  target='_blank'
                />
              )
            : link && (
                <span
                  className='break-all leading-[18px] text-success-400'
                  dangerouslySetInnerHTML={{ __html: link }}
                ></span>
              )}
        </div>
      </div>
      {(searchScreenUrl || linkScreenUrl) && (
        <p className={'pt-[12px] text-aqua-300'}>
          {t('pages.paidResults.screenshots')}:{' '}
          <a className={'text-default'} href={searchScreenUrl} rel='noreferrer' target={'_blank'}>
            {t('pages.paidResults.buttons.serp')}
          </a>
          ,{' '}
          <a className={'text-default'} href={linkScreenUrl} rel='noreferrer' target={'_blank'}>
            {t('pages.paidResults.buttons.landingPage')}
          </a>
        </p>
      )}
    </article>
  )
}
